import { DcrKeyValue } from '@ddt-web/config';

export interface InvestmentGuidingPrinciple {
	principle: DcrKeyValue;
	description: DcrKeyValue;
}


// the models type string would be appended to each dcr keys to make it more specific to the models
export const investmentGuidingPrinciples: InvestmentGuidingPrinciple[] = [
	{
		principle: {
			dcrKey: 'INVESTMENT_PRINCIPLE1_HEADER',
			dcrValue: 'Balance income and risk'
		},
		description: {
			dcrKey: 'INVESTMENT_PRINCIPLE1_DESC',
			dcrValue: `Generate attractive yield while diversifying risks`
		}
	},
	{
		principle: {
			dcrKey: 'INVESTMENT_PRINCIPLE2_HEADER',
			dcrValue: 'Broaden your scope'
		},
		description: {
			dcrKey: 'INVESTMENT_PRINCIPLE2_DESC',
			dcrValue: `Flexible multi-asset universe across regions and sectors, with an emphasis on tax-advantaged municipal bonds`
		}
	},
	{
		principle: {
			dcrKey: 'INVESTMENT_PRINCIPLE3_HEADER',
			dcrValue: 'Stay nimble via disciplined trading'
		},
		description: {
			dcrKey: 'INVESTMENT_PRINCIPLE3_DESC',
			dcrValue: `Dynamically adapt through semi-annual trades with ad-hoc flexibility`
		}
	},
	{
		description: {
			dcrKey: 'INVESTMENT_PRINCIPLE4_DESC',
			dcrValue: `Built with iShares and 3rd party ETFs alongside targeted active funds`
		},
		principle: {
			dcrKey: 'INVESTMENT_PRINCIPLE4_HEADER',
			dcrValue: 'Differentiated exposures'
		}
	},
	{
		principle: {
			dcrKey: 'INVESTMENT_PRINCIPLE5_HEADER',
			dcrValue: 'Diversify your return sources'
		},
		description: {
			dcrKey: 'INVESTMENT_PRINCIPLE5_DESC',
			dcrValue: `Consistent income stream may complement your total return strategy and amplify your retirement income`
		}
	},
	{
		description: {
			dcrKey: 'INVESTMENT_PRINCIPLE6_DESC',
			dcrValue: `For equities and fixed income from benchmark`
		},
		principle: {
			dcrKey: 'INVESTMENT_PRINCIPLE6_HEADER',
			dcrValue: '+/- 10% max deviation'
		}
	}
];
